import { useMemo } from 'react';
import { Package, AlertCircle } from 'lucide-react';
import { ResponsiveStatsGrid, ResponsiveGridItem } from '../../../components/ui/ResponsiveGrid';
import { TodayOrderStats } from '../../../api/orders';
import { StickerInventorySummary } from '../../../api/ems';

interface OrderStatsProps {
    todayStats?: TodayOrderStats;
    emsInventory?: StickerInventorySummary;
}

export function OrderStatsDisplay({ todayStats, emsInventory }: OrderStatsProps) {
    const stats = useMemo(() => {
        const todayOrders = todayStats?.totalOrders || 0;
        const todayRevenue = todayStats?.totalRevenue || 0;
        const emsAvailable = emsInventory?.available || 0;

        return [
            {
                key: 'today',
                label: 'ทั้งหมดวันนี้',
                value: todayOrders,
                icon: <Package className="h-4 w-4" />,
                accentClass: 'rounded-full bg-yellow-100 text-yellow-600 dark:bg-yellow-900/30 dark:text-yellow-200',
            },
            {
                key: 'revenue',
                label: 'ยอดขาย',
                value: `฿${todayRevenue.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
                icon: <AlertCircle className="h-4 w-4" />,
                accentClass: 'rounded-full bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-200',
            },
            {
                key: 'ems',
                label: 'เลข EMS ในระบบคงเหลือ',
                value: emsAvailable,
                icon: <Package className="h-4 w-4" />,
                accentClass: 'rounded-full bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-200',
            },
        ];
    }, [todayStats, emsInventory]);

    return (
        <ResponsiveStatsGrid>
            {stats.map((stat) => (
                <ResponsiveGridItem
                    key={stat.key}
                    className="flex items-center gap-3"
                >
                    <div className={`${stat.accentClass} p-2`}>
                        {stat.icon}
                    </div>
                    <div className="min-w-0 flex-1">
                        <p className="text-xs font-medium text-stone-500 dark:text-stone-400 truncate">
                            {stat.label}
                        </p>
                        <p className="text-lg font-mono font-bold text-stone-900 dark:text-white truncate">
                            {stat.value}
                        </p>
                    </div>
                </ResponsiveGridItem>
            ))}
        </ResponsiveStatsGrid>
    );
}
